import { CheckoutAdapter as y } from "../../../checkout/checkout.adapter.js";
import { Adapter as A, getAdapter as h } from "../../../../adapter.js";
import { ShopSessionConfigurationModel as f } from "./configuration.model.js";
import { ShopSessionPaymentMethodAdapter as u } from "./paymentMethod/paymentMethod.adapter.js";
class d extends A {
  adapt(o) {
    var e, i, s, p, n, r, t, m, c, l;
    const g = h(u);
    return new f({
      shop: {
        settings: {
          legal: {
            cookiesPolicy: ((s = (i = (e = o == null ? void 0 : o.shop) == null ? void 0 : e.settings) == null ? void 0 : i.legal) == null ? void 0 : s.cookies_policy) ?? void 0,
            privacyPolicy: ((r = (n = (p = o == null ? void 0 : o.shop) == null ? void 0 : p.settings) == null ? void 0 : n.legal) == null ? void 0 : r.privacy_policy) ?? void 0,
            termsAndConditions: ((c = (m = (t = o == null ? void 0 : o.shop) == null ? void 0 : t.settings) == null ? void 0 : m.legal) == null ? void 0 : c.terms_and_conditions) ?? void 0
          }
        }
      },
      checkout: h(y).adapt(o.checkout),
      payment: {
        methods: (l = o == null ? void 0 : o.payment) != null && l.methods ? o.payment.methods.map(g.adapt) : []
      }
    });
  }
  serialize(o) {
  }
}
export {
  d as ShopSessionConfigurationAdapter
};
//# sourceMappingURL=configuration.adapter.js.map
